/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { GroupingModule, OtmId } from 'common-typescript/types';
import { Action, InputType } from '../../study-boxes/study-action-box/study-action-box.component';

@Component({
    selector: 'sis-plan-structure-grouping-module-box',
    standalone: false,
    templateUrl: './plan-structure-grouping-module-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanStructureGroupingModuleBoxComponent {
    @Input({ required: true }) module: GroupingModule;
    @Input() action?: Action;
    @Input() actionInputId: string;
    @Input() actionInputName: string;
    @Output() actionChange? = new EventEmitter<OtmId>();
    @Input() selected?: boolean;
    @Input() inputType?: InputType;
    @Input() mandatory?: boolean;

    toggleSelected(): void {
        this.actionChange.emit();
    }
}
